<template>
  <div
    id="popup-container"
    style="display: flex; height: 100%; flex-direction: column"
  >
    <v-toolbar dark color="primary" style="max-height: 64px !important">
      <v-toolbar-title class="heading-title">
        Create New Playlist
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.name"
              v-model="channel.name"
              label="Playlist Name"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>Enter Playlist Name</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-textarea
              v-model="channel.description"
              label="Description"
              hint="Enter a description for this playlist"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>Enter a description for this playlist</span>
                </v-tooltip>
              </template>
            </v-textarea>
            <v-select
              :error-messages="messages.thumbnail"
              :items="ChannelOptions"
              v-model="channel.thumbnail"
              item-value="id"
              item-text="name"
              label="Thumbnail (Please choose either an icon or upload your own image)"
              filled
              attach
            >
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span
                    >Please choose either an icon or upload your own image</span
                  >
                </v-tooltip>
              </template>
            </v-select>
          </v-form>
        </v-col>
      </v-row>
      <v-row v-if="channel.thumbnail == 'icon'">
        <v-col md="12" class="text-center">
          <i class="fa super-size-icon" :class="'fa-' + selectedIcon"></i>
        </v-col>
        <v-col md="12">
          <icon-picker />
        </v-col>
      </v-row>
      <v-row v-if="channel.thumbnail == 'image'">
        <v-col md="12">
          <drop-zone
            :type="type"
            :accepted="accepted"
            class="mt-5 dropzone-container"
            text="Click here to upload Playlist Image"
          ></drop-zone>
          <template>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="dropzone-help">fa fa-question</v-icon>
              </template>
              <span>Upload Playlist Image</span>
            </v-tooltip>
          </template>
          <p class="block text-left mt-4 caption">
            Max upload filesize: 10MB <br />
            Accepted file formats: png, jpg
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-footer height="68" style="margin-top: auto">
      <v-flex px-4 py-4 text-right>
        <v-btn
          v-if="!loading"
          color="grey300"
          class="cancel-button"
          @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" loading></v-btn>
        <v-btn
          v-else
          color="primary"
          class="ml-4 add-course-button"
          @click.prevent="addChannel"
          >Add New Playlist</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import channelAPI from '@/api/channel.js';
import IconPicker from '@/components/admin/global/IconPicker';
import DropZone from '@/components/global/Dropzone';

export default {
  name: 'CreateChannel',
  components: {
    IconPicker,
    DropZone,
  },
  props: {
    params: {
      type: String,
      default: null,
    },
  },
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
  },
  data() {
    return {
      channel: {},
      type: 'thumbnail',
      selectedIcon: null,
      messages: {},
      loading: false,
      successMessage: 'Playlist Successfully Added.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      ChannelOptions: [
        {
          id: 'icon',
          name: 'Choose an icon',
        },
        {
          id: 'image',
          name: 'Upload an image',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    this.setEventBus();
    this.channel.levels = 1;
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    addChannel() {
      this.loading = true;
      if (this.channel.thumbnail == 'image') {
        channelAPI
          .createChannel(
            this.channel,
            this.$store.getters.s3Url,
            this.$store.getters.fileDetails
          )
          .then(() => {
            this.closePanel();
            EventBus.$emit('CHANNELS_UPDATED', this.params);
          })
          .catch((err) => {
            this.loading = false;
            this.messages = this.$gf.errorResponse(err);
            if (this.messages.file) {
              this.messages.thumbnail = this.messages.file;
            }
          });
      } else {
        channelAPI
          .createChannel(this.channel)
          .then(() => {
            this.closePanel();
            EventBus.$emit('CHANNELS_UPDATED', this.params);
          })
          .catch((err) => {
            this.loading = false;
            this.messages = this.$gf.errorResponse(err);
            if (this.messages.icon) {
              this.messages.thumbnail = this.messages.icon;
            }
          });
      }
    },
    setEventBus() {
      EventBus.$on('ICON_SELECT', (payload) => {
        this.channel.icon = payload;
        this.selectedIcon = payload;
      });
    },
  },
};
</script>
<style>
.super-size-icon {
  font-size: 200px;
}
</style>
